import { CustomRoutes } from '@shared/consts/routes/custom-routes.const';
import { ProjectsListComponent } from '@modules/projects/modules/projects-list/pages/projects-list/projects-list.component';

export const ProjectsListRoutes: CustomRoutes = [
  {
    path: '',
    name: 'projects-list',
    component: ProjectsListComponent,
    data: {
      metaTitle: 'Projects.list',
    },
  },
];
